import {AfterViewInit, Component, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {GenericListComponent} from '../../../../../../components/generic/generic-list/generic-list.component';
import {ColumnType} from '../../../../../../components/generic/generic-list/columnType';
import {PlayerProfileEvent} from '../../../../model/player-profile-event';
import {ConfirmationService, PrimeTemplate} from 'primeng/api';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {
  DateTimePresenterComponent
} from '../../../../../shared/common/date-time-presenter/date-time-presenter.component';
import {DomainValuePipe} from '../../../../../../pipes/domain-value.pipe';
import {ViewService} from '../../../../../shared/service/view.service';
import {AddressPipe} from '../../../../../../pipes/address.pipe';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {PlayerEvent} from '../../../../model/player-event';
import {FrontendService} from '../../../../../../services/frontend.service';
import {NgTemplateOutlet} from '@angular/common';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {CalendarItemEvent} from '../../../../model/calendar-item-event';
import {PlayerProfileEventMatch} from '../../../../model/player-profile-event-match';

@Component({
  selector: 'app-player-profile-calendar-table',
  imports: [
    GenericListComponent,
    PrimeTemplate,
    TranslatePipe,
    DateTimePresenterComponent,
    DomainValuePipe,
    AddressPipe,
    Button,
    Tooltip,
    NgTemplateOutlet
  ],
  templateUrl: './player-profile-calendar-table.component.html',
  styleUrl: './player-profile-calendar-table.component.scss'
})
export class PlayerProfileCalendarTableComponent implements AfterViewInit
{
  public view = inject(ViewService);
  private translate = inject(TranslateService);
  private confirmationService = inject(ConfirmationService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);
  private frontendService = inject(FrontendService);

  @Input() data: CalendarItemEvent[];
  @Output() reloadData = new EventEmitter<any>();

  @ViewChild('dateTemplate') dateTemplate: any;
  @ViewChild('eventInfoTemplate') eventInfoTemplate: any;
  @ViewChild('matchInfoTemplate') matchInfoTemplate: any;
  @ViewChild('eventAddressTemplate') eventAddressTemplate: any;
  @ViewChild('eventButtonsTemplate') eventButtonsTemplate: any;

  columns: any[];
  columnsMobile: ColumnType[];
  isDeregistering: boolean;

  ngAfterViewInit(): void
  {
    this.initColumns();
  }

  private initColumns(): void
  {
    console.log('dateTemplate', this.dateTemplate);
    this.columns = [
      {
        key: 'DATE', header: 'DATE', field: 'date', datatype: 'template', width: '60', class: 'text-center',
        template: this.dateTemplate
      },
      {
        key: 'TP', header: 'TYPE', field: 'type', width: '80', class: 'text-center'
      },
      {
        key: 'EI', header: 'EVENT', field: '', datatype: 'template', width: '',
        template: this.eventInfoTemplate
      },
      {
        key: 'EA', header: 'ADDRESS', field: '', datatype: 'template', width: '',
        template: this.eventAddressTemplate
      },
      {
        key: 'MI', header: 'INFO_SHORT', datatype: 'template', width: '70', template: this.matchInfoTemplate
      },
      {
        key: 'BTN', header: '', datatype: 'template', width: '60', class: 'text-center',
        template: this.eventButtonsTemplate
      }
    ];

    this.columnsMobile = [
      {
        key: 'MAT',
        header: 'REGISTRATIONS'
      }
    ];
  }

  public onRowSelect(item: any): void
  {
    console.log('Item', item);
  }

  public openEventInfos(event: PlayerProfileEvent): void
  {
    console.log('openEventInfos', event);
    if (event?.event?.database >= 0)
    {
      const url = FrontendService.getFrontendEventUriWithDatabase(event.event.database) + event.event.eventId;
      if (!url.includes('undefined'))
        window.open(url, '_blank');
    }
  }

  public openLeagueMatchplan(match: PlayerProfileEventMatch): void
  {
    console.log('openLeagueMatchplan', match);
    if (match?.database >= 0 && match.matchId > 0)
    {
      // Phase und Round-Infos aus Backend abrufen, dann Link generieren
      this.frontendService.getMatchDatabaseLinkInfo(match.database, match.matchId).subscribe({
        next: data =>
        {
          console.log('Match-Linkinfos erhalten', data);
          const phaseId = data.phase?.id;
          const roundId = data.round?.id;
          const eventParam = {
            dbId: match.database,
            id: match.event.eventId
          };

          // https://portal.3k-darts.com/frontend/events/10/event/301/phase/287/group/9979?matchId=325958
          const url = FrontendService.getMatchplanDirektLink(eventParam, phaseId, roundId, match.matchId);
          if (!url.includes('undefined'))
            window.open(url, '_blank');
        },
        error: error =>
        {
          this.restErrorHelper.handleErrorService(error);
        }
      });
    }
  }

  public deregisterFromEvent(event: PlayerProfileEventMatch): void
  {
    if (this.isDeregistering || !event.event)
      return;

    this.confirmationService.confirm({
      message: this.translate.instant('MSG_DEREGISTER_FROM_EVENT_X', {value: event.event.name}),
      header: this.translate.instant('DEREGISTER'),
      icon: 'pi pi-question-circle',
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      rejectButtonStyleClass: 'button-no button-right',
      accept: () => this.deregisterFromEventService(event.event)
    });
  }

  private deregisterFromEventService(event: PlayerEvent): void
  {
    if (this.isDeregistering || !event)
      return;

    this.isDeregistering = true;
    this.playerProfileService.deregisterFromEvent(event.eventId).subscribe({
      next: response =>
      {
        console.log('Erfolgreich vom Turnier abgemeldet', response);
        this.data = response;
        setTimeout(() =>
          {
            this.isDeregistering = false;
            this.reloadData.emit();
          }, 500);
      },
      error: error =>
      {
        this.isDeregistering = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }
}
